module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Files/Locked-folder-a047a239ab681921e750a02dcd854fdb.svg";